import axios from "axios";

export const getReques = () => {
  return {
    type: "GET_STATE",
  };
};

export const getActionSucces = (data) => {
  return {
    type: "GET_SUCCESS",
    payload: data,
  };
};
